import { Object3D } from 'three'
import Interactive from './Interactive'
import { GAME_OBJECTS } from './types'

export default class Obstacle extends Interactive {
  constructor(obj: Object3D) {
    super(obj)
    this.types.push(GAME_OBJECTS.OBSTACLE)
  }
}
